import { t, type I18nLocale } from '@ardoq/i18n';

export const getConvertedSlideCannotBeSavedText = (
  i18nLocale: I18nLocale
): string =>
  t(
    i18nLocale,
    'presentationEditor:convertedSlide.cannotBeSaved',
    "You can't save a slide that was converted from workspace mode."
  );
